import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CheckIcon, ClockIcon, MoonIcon, SoupIcon, ActivityIcon, Loader2Icon } from "lucide-react";
import { loadingChecks, loadingPhases } from "../data/offer";
import { withName } from "../utils/name";
const PHASE_MS = 3000;
export function LoadingScreen({
  name,
  onComplete
}: {
  name: string;
  onComplete: () => void;
}) {
  const [phase, setPhase] = useState(0);
  useEffect(() => {
    const timers = loadingPhases.map((_, i) => window.setTimeout(() => setPhase(i + 1), PHASE_MS * (i + 1)));
    const done = window.setTimeout(onComplete, PHASE_MS * loadingPhases.length + 500);
    return () => {
      timers.forEach(window.clearTimeout);
      window.clearTimeout(done);
    };
  }, [onComplete]);
  const checksDone = Math.round(phase / loadingPhases.length * loadingChecks.length);
  return <section className="mx-auto max-w-xl px-4 py-10 sm:px-6 md:py-16" aria-live="polite" data-id="element-86" data-mp="waxtl225vww3">
      <div className="mb-6 flex justify-center gap-3 text-rose-600" aria-hidden="true" data-id="element-87" data-mp="rgjw8u3xvfos">
        {[ClockIcon, ActivityIcon, MoonIcon, SoupIcon].map((Icon, i) => <span key={i} className="flex h-11 w-11 items-center justify-center rounded-full bg-blush-100" data-id="element-88" data-mp="2m4n0fsorkthe" data-mpi={i}>
            <Icon className="h-5 w-5" data-id="element-89" data-mp="27fz6fqukgrtk" />
          </span>)}
      </div>
      <h2 className="text-center font-serif text-3xl font-semibold text-cocoa" data-id="element-90" data-mp="2cfbswahizwvm">
        {withName("Estamos analizando tus respuestas, {nombre}…", name)}
      </h2>

      <div className="mt-8 rounded-3xl bg-white p-6" data-id="element-91" data-mp="1yi6saq0kzq7r">
        <div className="h-2 w-full overflow-hidden rounded-full bg-blush-100" data-id="element-92" data-mp="22iqmbkpuydpo">
          <motion.div className="h-full rounded-full bg-rose-600" initial={{
          width: "0%"
        }} animate={{
          width: "100%"
        }} transition={{
          duration: PHASE_MS * loadingPhases.length / 1000,
          ease: "linear"
        }} data-id="element-93" data-mp="1oiftwd8wgr2e" />
        </div>
        <ol className="mt-5 space-y-3" data-id="element-94" data-mp="3nv0eaxf4snub">
          {loadingPhases.map((label, i) => {
          const state = i < phase ? "done" : i === phase ? "active" : "idle";
          return <li key={label} className="flex items-center gap-3 text-base" data-id="element-95" data-mp="3mf63fjcqi13a" data-mpi={i}>
                <span className={`flex h-6 w-6 items-center justify-center rounded-full ${state === "done" ? "bg-olive-600 text-white" : "bg-cream-dark text-cocoa-soft"}`} data-id="element-96" data-mp="3hdz0bxljdq2y">
                  {state === "done" ? <CheckIcon className="h-3.5 w-3.5" data-id="element-97" data-mp="37hvx0oey7lef" /> : state === "active" ? <Loader2Icon className="h-3.5 w-3.5 animate-spin" data-id="element-98" data-mp="8yp1qzguv2zx" /> : null}
                </span>
                <span className={state === "idle" ? "text-cocoa-faint" : "font-medium text-cocoa"} data-id="element-99" data-mp="405emvqizl5z">{label}</span>
              </li>;
        })}
        </ol>
      </div>

      <div className="mt-8" data-id="element-100" data-mp="3vcq6mxu5q7gj">
        <p className="text-sm font-semibold text-cocoa" data-id="element-101" data-mp="3qfq2wtks5gsl">Estamos revisando:</p>
        <ul className="mt-3 space-y-2" data-id="element-102" data-mp="3qddkygf0v6fj">
          {loadingChecks.map((item, i) => <li key={item} className="flex items-start gap-2.5 text-base text-cocoa-soft" data-id="element-103" data-mp="rr10zdc7po5u" data-mpi={i}>
              <span className={`mt-2 h-1.5 w-1.5 shrink-0 rounded-full transition-colors duration-200 ${i < checksDone ? "bg-olive-600" : "bg-blush-200"}`} data-id="element-104" data-mp="mxy6n2zm2aol" />
              <span className={i < checksDone ? "text-cocoa" : ""} data-id="element-105" data-mp="z8pe9cir9vux">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}